export interface DappEmailData {
  contactEmail?: string | null;
  supportEmail?: string | null;
  publisherEmail?: string | null;
}

export function resolveContactEmail(
  dappData: DappEmailData,
  fallback = '',
): string {
  return (
    dappData.contactEmail ||
    dappData.supportEmail ||
    dappData.publisherEmail ||
    fallback
  );
}
